import { render, staticRenderFns } from "./SearchStatistics.vue?vue&type=template&id=d1e11d9e&scoped=true"
import script from "./SearchStatistics.vue?vue&type=script&lang=js"
export * from "./SearchStatistics.vue?vue&type=script&lang=js"
import style0 from "./SearchStatistics.vue?vue&type=style&index=0&id=d1e11d9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1e11d9e",
  null
  
)

export default component.exports